import { useState } from "react";
import { SiteData } from "./Data/SiteData";
import LayoutNode, {
  getNodeComponentAttributeValue,
} from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";

export default function RenderCustomCSS({
  siteData,
  root,
}: {
  siteData: SiteData;
  root: LayoutNode;
}) {
  const [renderTrigger, setRenderTrigger] = useState(false);

  const [styleString, setStyleString] = useState(
   ""
  );
  siteData.onUpdateCustomCSS = () => {
  
    setRenderTrigger(!renderTrigger);
    setStyleString(compileCustomCSS(siteData, root, true));
  };

  return (
    <style
      id="site-custom-css-styling"
      dangerouslySetInnerHTML={{ __html: styleString }}
    ></style>
  );
}

export function compileCustomCSS(
  siteData: SiteData,
  rootNode: LayoutNode,
  isEditor: boolean
) {
  let str = "";

  let pendingList = [rootNode];

  while (pendingList.length > 0) {
    let node = pendingList.pop();
    if (!node) continue;
    if (node.children)
      for (let i = 0; i < node.children.length; i++) {
        pendingList.push(node.children[i]);
      }

    let css = getCSSForNode(node, isEditor);
    if (css.length > 0) {
      str += css + "\n";
    }
  }

  str = str.replaceAll("<script", ""); //sanitize any scripting attempts

  return str;
}

const getCSSForNode = (node: LayoutNode, isEditor: boolean) => {
  let customCSS = getNodeComponentAttributeValue(
    node,
    componentAttributeTypes.customCSS,
    ""
  );

  if (
    customCSS.length < 3 ||
    customCSS.replaceAll(" ", "").replaceAll("\n", "").replaceAll("\t", "") ===
      "$all{}"
  )
    return "";

  if(customCSS.includes("<")){
    let inBracket = false;
    let newString = "";
    for(let i = 0;i<customCSS.length;i++){
      if(customCSS.charAt(i)=="<"){
        inBracket = true;
      }else if(customCSS.charAt(i)==">"&&inBracket){
        inBracket = false;
      }else if(!inBracket){
        newString += customCSS.charAt(i);
      }
    }

    customCSS = newString;

  }



  let containers = extractContainers(customCSS); // get any media queries or animations
  for (let i = 0; i < containers.length; i++)
    customCSS = customCSS.replace(containers[i], "");

  let split = customCSS.split("}");

  let newCSS = "";

  for (let i = 0; i < split.length; i++) {
    let newLine = split[i].trim();
    let head = newLine.split("{"); // split the line into the target and the body
    let targetStr = "";

    if (head.length < 2) {
      // invalid section, continue
      continue;
    } else {
      let target = head[0].split(","); // get all targets of this section

      for (let e = 0; e < target.length; e++) {
        // append $all if missing to all targets

        let et = target[e].trim();
        if (!et.startsWith("$") && !et.startsWith("@")) {
          et = "$all " + et;
        }

        targetStr += (e != 0 ? "," : "") + et;
      }
    }

    newLine = targetStr + "{" + head[1].trim();

    newCSS += newLine + "}\n";
  }

  customCSS = newCSS;

  let id = isEditor ? node.id : "v" + node.id;
  for (let i = 0; i < containers.length; i++) {
    customCSS += containers[i] + "\n";
  }



  customCSS = customCSS.replaceAll("$all", "#" + id);
  customCSS = customCSS.replaceAll("$mobile", ".mobile-break #" + id);
  customCSS = customCSS.replaceAll("$tablet", ".tablet-break #" + id);
  customCSS = customCSS.replaceAll(";", " !important;");

  return customCSS;
};

const extractContainers = (css: string) => {
  let containerList = [];
  let startIndex = 0;
  let bracketCount = 0;
  let inContainer = false;
  for (let i = 0; i < css.length; i++) {
    let char = css.charAt(i);
    if (char == "@") {
      inContainer = true;
      startIndex = i;
    } else if (char == "{") {
      if (inContainer) {
        bracketCount++;
      }
    } else if (char == "}") {
      if (inContainer) {
        bracketCount--;
        if (bracketCount == 0) {
          inContainer = false;
          containerList.push(css.substring(startIndex, i + 1));
        }
      }
    }
  }

  return containerList;
};
